import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { UploadImage } from 'services/api';
import { exposeStrapiError } from 'utils';
import { UploadFileContent } from './styled';

// Mapeamento de tipos de arquivo aceitos por tipo de proposta
const acceptedFileTypes = {
  Elegiveis: { 'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png'] },
  A_Pagar: { 'application/pdf': ['.pdf'], 'image/png': ['.png'] },
  A_Formalizar: { 'application/pdf': ['.pdf'] },
};

const UploadFile = ({
  onChange,
  onPreview,
  children,
  validate,
  proposalType = 'A_Formalizar',
}) => {
  const uploadFile = useCallback(
    async (file) => {
      const result = await UploadImage(file);
      if (!exposeStrapiError(result)) {
        if (onChange && typeof onChange === 'function' && result?.length) {
          onChange(result[0]);
        }
      }
    },
    [onChange]
  );

  const onDrop = useCallback(
    async (acceptedFiles) => {
      const [file] = acceptedFiles;
      if (!file) {
        return;
      }

      if (validate && typeof validate === 'function') {
        const isValid = await validate(file);
        if (!isValid) {
          return;
        }
      }

      if (
        onPreview &&
        typeof onPreview === 'function' &&
        file.type.startsWith('image/')
      ) {
        onPreview(URL.createObjectURL(file));
      }

      await uploadFile(file);
    },
    [onPreview, validate, uploadFile]
  );

  const onDropRejected = useCallback(
    (fileRejections) => {
      const errorMessage =
        proposalType === 'Elegiveis'
          ? 'Arquivo não aceito. Use apenas imagens (JPEG ou PNG) para a Fatura.'
          : 'Arquivo não aceito. Use apenas arquivos PDF.';

      toast.error(errorMessage);
    },
    [proposalType]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDropRejected,
    maxFiles: 1,
    accept: acceptedFileTypes[proposalType],
  });

  return (
    <UploadFileContent {...getRootProps()}>
      <input {...getInputProps()} style={{ display: 'none' }} />
      {children}
    </UploadFileContent>
  );
};

UploadFile.propTypes = {
  onChange: PropTypes.func,
  onPreview: PropTypes.func,
  children: PropTypes.element.isRequired,
  validate: PropTypes.func,
  proposalType: PropTypes.oneOf(['Elegiveis', 'A_Pagar', 'A_Formalizar']),
};

UploadFile.defaultProps = {
  onChange: undefined,
  onPreview: undefined,
  validate: undefined,
  proposalType: 'A_Formalizar',
};

export default UploadFile;
